import type { Entries, ValueOf } from '../types/types'

export const getObjectKeys = <T extends Record<string, unknown>>(
  obj: T,
): (keyof T)[] => Object.keys(obj) as (keyof T)[]

export const getObjectValues = <T extends Record<string, unknown>>(
  obj: T,
): ValueOf<T>[] => Object.values(obj) as ValueOf<T>[]

export const getObjectEntries = <T extends Record<string, unknown>>(
  obj: T,
): Entries<T> => Object.entries(obj) as Entries<T>

/**
 * A strongly-typed version of `
Object.fromEntries()`.
 *
 * https://github.com/sindresorhus/ts-extras/blob/main/source/object-from-entries.ts
 */
export const getObjectFromEntries = Object.fromEntries as <
  Entries extends readonly (readonly [PropertyKey, unknown])[],
>(
  values: Entries,
) => number extends Entries['length']
  ? { [T in Entries[number] as T[0]]?: T[1] }
  : { [T in Entries[number] as T[0]]: T[1] }
